// @ts-nocheck
import React from 'react';
import FormInput from '../../common/FormInput';
import FormStatic from '../../common/FormStatic';
import FormTextArea from '../../common/FormTextArea';
import { useTranslation } from 'react-i18next';

export interface EditRequestValueFormProps {
  request: Record<string, unknown>;
  register: unknown;
  errors: Record<string, unknown>;
}

const EditRequestValueForm = ({ request, register, errors }: EditRequestValueFormProps) => {
  const { t } = useTranslation('requests');
  return (
    <>
      <FormStatic label="Current request value">
        {request.currentRequestValue}
      </FormStatic>
      <FormInput
        register={register}
        required={true}
        pattern={/^[0-9,.]+$/i}
        error={errors.newRequestValue}
        errorMessage={t('Number required')}
        name="newRequestValue"
        label={t('New request value')}
        className="num"
        defaultValue={request.currentRequestValue || 0}
        autoFocus={true}
      />
      <FormTextArea
        register={register}
        required={true}
        error={errors.reason}
        errorMessage={t('Required')}
        name="reason"
        label={t('Please provide a reason...')}
        placeholder=""
      />
    </>
  );
};

export default EditRequestValueForm;
